import { VideoTutorialLocation } from '@akin-home/video-tutorials';
import { useTutorialVideos } from './useTutorialVideos';

interface Params {
  location: VideoTutorialLocation;
}

/** Fetches a tutorial video for the given location */
export const useTutorialVideo = ({ location }: Params) => {
  const { data, isLoading } = useTutorialVideos();

  return {
    video: data?.find((vid) => vid.location === location),
    isLoading,
  };
};
